import React from "react";

const Footer = ({ version }) => {
  return (
    <React.Fragment>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              © {new Date().getFullYear()} Nexion SPA -{" "}
              <b>
                Powered by Nexion Engineering.{" "}
                {/* {version ? ` version - ${version}` : ""} */}
                Version - 03.00.00
              </b>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
